// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6O3b0","footer":"styles_footer__MMXPp","passCodeTooltip":"styles_passCodeTooltip__3weHo"};